var map = {
	"./err-1.png": "KI46",
	"./err-10.png": "azis",
	"./err-2.png": "kESN",
	"./err-3.png": "T9iz",
	"./err-4.png": "K1nZ",
	"./err-5.png": "blwD",
	"./err-6.png": "vNBx",
	"./err-7.png": "S9P4",
	"./err-8.png": "+dnp",
	"./err-9.png": "Ofqr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eteW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2 ^\.\/err\-.*\.png$
// module id = eteW
// module chunks = 1